<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" :loading="loading" destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" ref="campaigntaskList"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
				<campaignTaskForm :data="currentrow" ref="campaignTaskForm" @success="campaignTaskFormSuccess" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import campaignTaskForm from './form.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_model: false,
				modal_title: '任务',
				modal_width: 1000,
				modal_height: 800,
				loading:false,
				currentrow: {},
				list_formConfig: [{
						field: 'name',
						title: '任务名称',
						itemRender: {
							name: '$input'
						}
					},
					// {
					// 	field: 'mark',
					// 	title: '备注',
					// 	itemRender: {
					// 		name: '$input'
					// 	}
					// }
				],
				list_columns: [{
						field: 'name',
						title: '任务名称',
						width:100,
					},					
					{
						field: 'type',
						title: '出价方式',
						width:100,
						slots: {
							default: ({row}) => {
								if(row.type == 'smart_bid'){
									return '智能出价'
								}
								if(row.type == 'roi_control'){
									return '控投产比投放'
								}
								if(row.type == 'max_amount'){
									return '最大化拿量'
								}
								if(row.type == 'status'){
									return '推广状态'
								}
							}
						}
					},
					{
						field: 'typeChange',
						title: '出价方式切换',
						width:100,
						slots: {
							default: ({row}) => {
								if(row.typeChange == 1){
									return '是'
								}
								if(row.typeChange == 0){
									return '否'
								}
							}
						}
					},
					{
						field: 'level',
						title: '优先级',
						width:100,
					},
					{
						field: 'mark',
						title: '备注',
						width:100,
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 160,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.action(row)}}>执行</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>
								]
							}
						}
					}
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			action(row) {
				this.$prompt('请输入计划ID', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({
					value
				}) => {
					this.loading = true
					this.$api.campaign.actiontask({
						taskid: row.id,
						campaignId:value
					}).then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
					}, () => {
						this.loading = false
					})
				}).catch(() => {

				})
			},
			add() {
				this.currentrow = {}
				this.$refs.campaignTaskForm.modal_show()
			},
			edit(row) {
				this.currentrow = row
				this.$refs.campaignTaskForm.modal_show()
			},
			del(row) {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.campaign.deletetask({
						id: row.id
					}).then(() => {
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					}, () => {
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})
			},
			campaignTaskFormSuccess() {
				this.customreload()
			},
			list_beforeCreateGrid(gridOptions) {
				// gridOptions.formConfig.span = 4
				// gridOptions.pagerConfig.enabled = true
				gridOptions.toolbarConfig.buttons = [{
					name: '新增',
					status: 'primary',
					code: 'add'
				}]
			},
			list() {
				return new Promise((resolve) => {
					this.$api.campaign.listtask().then((res) => {
						resolve(res)
					}, () => {
						resolve()
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			customreload() {
				this.$refs.campaigntaskList.commitProxy('query')
			}
		},
		components: {
			campaignTaskForm
		}
	}
</script>